{
    "type": "object",
    "properties": {
        "annotations": {
            "$ref": "#/definitions/ITenantData"
        },
        "id": {
            "type": "string"
        },
        "name": {
            "type": "string"
        },
        "displayName": {
            "type": "string"
        },
        "organizationId": {
            "type": "string"
        },
        "serviceId": {
            "type": "string"
        },
        "labels": {
            "$ref": "#/definitions/ITenantData"
        },
        "systemId": {
            "type": "string"
        }
    },
    "additionalProperties": false,
    "required": [
        "displayName",
        "id",
        "labels",
        "name",
        "organizationId",
        "serviceId",
        "systemId"
    ],
    "definitions": {
        "ITenantData": {
            "type": "object",
            "additionalProperties": {
                "type": [
                    "string",
                    "number",
                    "boolean"
                ]
            },
            "properties": {
                "URL": {
                    "type": "string"
                }
            }
        }
    },
    "$schema": "http://json-schema.org/draft-07/schema#"
}
